import React from 'react';
import { CyberBackground, NeonText } from '../components/CyberEffects';
import './LegalPage.css';

function Privacy({ navigate }) {
  return (
    <div className="legal-container animate-fade-in">
      <CyberBackground showParticles={false} />

      <div className="legal-content">
        <button className="back-btn" onClick={() => navigate('home')}>
          ← 戻る
        </button>

        <h1 className="legal-title">
          <NeonText color="accent" size="lg">プライバシーポリシー</NeonText>
        </h1>

        <div className="legal-body">
          <div className="legal-section">
            <h2>1. はじめに</h2>
            <p>
              株式会社Eight Goodが運営するクイズ ワン ワード（以下「本サービス」）は、
              ユーザーのプライバシーを尊重し、個人情報の保護に努めます。
              本プライバシーポリシーでは、本サービスが収集する情報とその利用方法について説明します。
            </p>
          </div>

          <div className="legal-section">
            <h2>2. 収集する情報</h2>
            <h3>2.1 自動的に収集される情報</h3>
            <ul>
              <li>匿名の識別子（Firebase Anonymous Auth UID）</li>
              <li>ゲームプレイデータ（ルーム参加履歴、スコア等）</li>
              <li>端末情報（ブラウザ種別、OS等）</li>
            </ul>

            <h3>2.2 ユーザーが提供する情報</h3>
            <ul>
              <li>ニックネーム</li>
              <li>アカウント登録時のメールアドレス（任意）</li>
            </ul>

            <h3>2.3 決済情報</h3>
            <p>
              有料サービスをご利用の場合、決済処理は Stripe, Inc. を通じて行われます。
              クレジットカード情報は本サービスのサーバーには保存されません。
            </p>
          </div>

          <div className="legal-section">
            <h2>3. 情報の利用目的</h2>
            <ul>
              <li>本サービスの提供および運営</li>
              <li>ゲーム機能の提供（マッチング、スコア管理等）</li>
              <li>サービスの改善および新機能の開発</li>
              <li>お問い合わせへの対応</li>
              <li>広告の配信（Google AdSense）</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>4. 第三者への提供</h2>
            <p>以下の場合を除き、個人情報を第三者に提供することはありません。</p>
            <ul>
              <li>ユーザーの同意がある場合</li>
              <li>法令に基づく場合</li>
              <li>サービス提供に必要な業務委託先（以下参照）</li>
            </ul>

            <h3>利用している外部サービス</h3>
            <ul>
              <li>Firebase（Google LLC）- 認証、データベース</li>
              <li>Stripe, Inc. - 決済処理</li>
              <li>Google AdSense - 広告配信</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>5. Cookie および類似技術</h2>
            <p>
              本サービスでは、サービスの提供および広告の配信のために
              Cookie およびローカルストレージを使用しています。
              ブラウザの設定により Cookie を無効にすることができますが、
              一部の機能が利用できなくなる場合があります。
            </p>
          </div>

          <div className="legal-section">
            <h2>6. データの保管</h2>
            <p>
              収集したデータは、サービスの提供に必要な期間保管されます。
              アカウントを削除した場合、関連するデータは合理的な期間内に削除されます。
            </p>
          </div>

          <div className="legal-section">
            <h2>7. お問い合わせ</h2>
            <p>
              プライバシーに関するお問い合わせは、以下の連絡先までお願いいたします。
            </p>
            <div className="legal-contact">
              <p>メール: info@quiz-oneword.com</p>
            </div>
          </div>

          <div className="legal-section">
            <h2>8. 改定</h2>
            <p>
              本ポリシーは、法令の変更やサービス内容の変更に伴い、
              予告なく改定される場合があります。重要な変更がある場合は、
              本サービス上でお知らせします。
            </p>
          </div>
        </div>

        <p className="legal-date">最終更新日: 2026年1月23日</p>
      </div>
    </div>
  );
}

export default Privacy;
